import { render, staticRenderFns } from "./AccountModal.vue?vue&type=template&id=460ff608&scoped=true&"
import script from "./AccountModal.vue?vue&type=script&lang=js&"
export * from "./AccountModal.vue?vue&type=script&lang=js&"
import style0 from "./AccountModal.vue?vue&type=style&index=0&id=460ff608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460ff608",
  null
  
)

export default component.exports